import React from 'react';
import { useStores } from 'src/components/store';
import CustomIcon, { IconType } from '../../custom-icon/custom-icon';
import { keyboardClickable } from '../../../../utils/a11y-utils';
import './upgrade-button.scss';

interface UpgradeButtonProps {
    showIcon?: boolean;
}

export const UpgradeButton: React.FC<UpgradeButtonProps> = ({ showIcon = true }) => {
    const { customerStore } = useStores();

    const handleClick = (e: React.SyntheticEvent) => {
        window.open(`/plan-upgrade-${customerStore.selectedLocation?.serviceLevel.toLocaleLowerCase()}`, '_blank');
        e.preventDefault();
    };

    return (
        <div className="upgrade-button" {...keyboardClickable(handleClick)}>
            {showIcon && <CustomIcon type={IconType.UPGRADE_PLAN} />}
            <span>Upgrade</span>
        </div>
    );
};
